"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogicalStreamType = void 0;
class LogicalStreamType {
    constructor(dictionary_type, offset_type, length_type) {
        if (dictionary_type) {
            this.dictionary_type = dictionary_type;
        }
        else if (offset_type) {
            this.offset_type = offset_type;
        }
        else if (length_type) {
            this.length_type = length_type;
        }
    }
    dictionaryType() {
        return this.dictionary_type;
    }
    offsetType() {
        return this.offset_type;
    }
    lengthType() {
        return this.length_type;
    }
}
exports.LogicalStreamType = LogicalStreamType;
//# sourceMappingURL=LogicalStreamType.js.map